export default "__VITE_ASSET__Cn6IfWBg__"